<template>
  <div class="group">
    <div class="group-item" v-for="item in groupList" :key="item.id">
      <div class="title">{{ item.name }}</div>
      <GroupAppItem :item="item"/>
    </div>
  </div>
</template>


<script>
import GroupAppItem from "@/views/GroupAppItem.vue";

export default {
  name: "GroupDesktop",
  components: {GroupAppItem},
  computed: {
    groupList() {
      let icons = []
      this.$store.state.core.applications.forEach(item => {
        icons.push(item)
      })
      return icons;
    }
  },
}
</script>

<style lang="less" scoped>
@import 'node_modules/joysun-frame/packages/css/global.less';

.group {
  color: #FFFFFF;
  display: flex;
  position: absolute;
  top: @taskHeight;
  flex-wrap: wrap;
  width: 1170px;

  .group-item {
    width: 370px;
    height: 230px;
    margin: 10px 10px 0;
    background-color: rgba(0, 48, 100, 0.4);
    border-radius: 10px;
    display: flex;
    flex-direction: column;

    .title {
      background-color: rgba(66, 85, 101, 0.2);
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      line-height: 30px;
      border-top-left-radius: inherit;
      border-top-right-radius: inherit;
    }
  }

}
</style>